import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/Card';
import CardHeader from 'components/Card/Header';
import CardText from 'components/Card/Text';
import Dialog from 'components/Dialog';
import { Close } from '@mui/icons-material';
import Image from 'components/Image';
import CredSM from 'assets/Cred-sm.png';
import { useRouter } from 'found';
import Button from '@mui/material/Button';
import useIsMobile from 'lib/useIsMobile';
import { useMediaQuery } from 'react-responsive';
import makeStyles from '@mui/styles/makeStyles';
import { APP_STORE_LINK, PLAY_STORE_LINK } from '../../utils/helper';

const styles = {
  card: {
    backgroundColor: 'white',
  },
  alignFlex: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: 20,
  },
  scoreIconSM: {
    width: '9px',
    height: '9px',
    verticalAlign: 'baseline',
  },
};

const DashboardAppOpen = ({ open, onCancel }) => {
  const btnStyle = makeStyles();
  const { router } = useRouter();
  const mobile = useIsMobile();
  const tablet = useMediaQuery({ maxWidth: 960 });
  const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) {
      return 'window';
    }
    if (/android/i.test(userAgent)) {
      return 'android';
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }
    if (
      /Macintosh/i.test(navigator.userAgent)
      && navigator.maxTouchPoints
      && navigator.maxTouchPoints > 1
    ) {
      return 'ios';
    }
    return 'unknown';
  };

  return (
    <Dialog modal onRequestClose={onCancel} open={open}>
      <Card style={styles.card}>
        <Close
          style={{ zIndex: 99, marginLeft: 20, marginTop: 12, color: '#000' }}
          onClick={() => {
            router.push('/activities');
          }}
        />
        <CardHeader
          titleStyle={{
            fontWeight: '700 !important',
            fontSize: '15px !important',
            color: '#0076BB',
            textAlign: 'center',
          }}
          title='Install the Ripple Street Activities App'
        />
        <CardText
          noTopPadding
          style={{
            fontWeight: '400 !important',
            fontSize: '13px !important',
            color: '#000000',
            lineHeight: '25px',
          }}
        >
          <div>
            Wanna increase your Ripple Street Cred&nbsp;
            <Image
              alt='up'
              showLoading={false}
              src={CredSM}
              style={styles.scoreIconSM}
            />{' '}
            ? It’s as easy as completing your activities. Even better news? We
            have an app for that. Download it today!
          </div>
          <br />
          <Button
            variant='contained'
            color='primary'
            size='small'
            className={btnStyle.button}
            style={{
              background: '#0076BB',
              position: 'relative',
              left: mobile ? '30%' : '40%',
              borderRadius: '20px',
            }}
            onClick={() => {
              if (mobile || tablet) {
                const device = getMobileOperatingSystem();
                if (device === 'window') {
                  window.location.href = PLAY_STORE_LINK;
                } else if (device === 'android') {
                  window.location.href = PLAY_STORE_LINK;
                } else if (device === 'ios') {
                  window.location.href = APP_STORE_LINK;
                } else if (device === 'unknown') {
                  const platform = navigator?.userAgentData?.platform || navigator?.platform;
                  if (platform.indexOf('Mac') >= 0 || platform === 'iPhone') {
                    window.open(
                      APP_STORE_LINK,
                      '_blank',
                    );
                  } else {
                    window.open(
                      PLAY_STORE_LINK,
                      '_blank',
                    );
                  }
                } else {
                  onCancel();
                }
              } else {
                const platform = navigator?.userAgentData?.platform || navigator?.platform;
                if (platform.indexOf('Mac') >= 0 || platform === 'iPhone') {
                  window.open(
                    APP_STORE_LINK,
                    '_blank',
                  );
                } else {
                  window.open(
                    PLAY_STORE_LINK,
                    '_blank',
                  );
                }
              }
            }}
          >
            VISIT APP STORE
          </Button>
        </CardText>
      </Card>
    </Dialog>
  );
};
DashboardAppOpen.propTypes = {
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool,
};
export default DashboardAppOpen;
